
// Reference

var fadeSpeed = 300;


//
// Base Modal
//

module.exports = function BaseModal ($host, config) {

  // Dom
  var $close = $('[data-modal-close]', $host);

  // State
  var state = { open: false };

  // Functions
  function reveal () {
    state.open = true;
    $host.css({
      opacity: 0,
      display: 'flex'
    }).animate({
      opacity: 1
    }, fadeSpeed);
  }

  function conceal () {
    state.open = false;
    $host.animate({
      opacity: 0
    }, {
      duration: fadeSpeed,
      complete: function () {
          $host.hide();
      }
    });
  }

  // Listeners
  $close.on('click', conceal);

  $(document).on('keydown', whichKey(27, function (event) {
    if (state.open) {
      conceal();
      event.preventDefault();
      event.stopPropagation();
    }
  }));

  // Interface
  return {
    reveal: reveal,
    conceal: conceal
  };

};

